export default {
  1: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '1.3rem',
        left: '1.09rem',
      },
    },
  },
  2: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '1.3rem',
        left: '1.09rem',
      },
      1: {
        top: '1.3rem',
        left: '1.81rem',
      },
    },
  },
  3: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        top: '1.3rem',
        left: '1.09rem',
      },
      1: {
        top: '1.3rem',
        left: '1.81rem',
      },
      2: {
        top: '1.3rem',
        left: '2.53rem',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/circleStylesDynaGroBrochure.ts